export function bodymovinHandler() {
    this.$window.on("load", function () {
        // if(!isIE) {
        let icons = $(".bodymovin");
    
        icons.each((i, item) => {
            if(item.getAttribute("data-icon-source").length) {
                let src = item.getAttribute("data-icon-source");
                let params = {
                    container: item,
                    path: src,
                    loop: true,
                    autoplay: true,
                    renderer: "svg", //'svg/canvas/html'
                    name: `icon${i}`
                };
                const anim = lottie.loadAnimation(params);
            }
        });
        // }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bodymovin-handler.js